module.exports = __webpack_public_path__ + "static/img/partner3.c15adc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/partner3.png
// module id = yWI6
// module chunks = 1